<template>
  <v-menu
    v-model="menu"
    transition="slide-y-transition"
    offset-y
    min-width="314px"
    max-width="314px"
    class="v-column-select"
    :close-on-content-click="false"
    v-bind="columnSelectProps"
  >
    <template #activator="{ on }">
      <div class="v-column-select-box" :style="btnStyle">
        <v-btn icon class="v-column-select-box-btn" :ripple="false" v-on="on">
          <v-icon size="15">mdi-cog</v-icon>
        </v-btn>
      </div>
    </template>
    <template #default>
      <v-card>
        <card-title large closeable @click:close="menu = false">
          {{ trans.tableSettings }}
        </card-title>
        <card-content
          class="px-4 pb-6 text-body-2 text-main--text"
          style="padding-top: 16px !important;"
        >
          <div class="mb-6">
            {{ trans.selectOrderColumns }}
          </div>
          <draggable
            v-model="userHeadersLazy"
            animation="200"
            handle=".handle"
            class="d-flex flex-column"
            style="row-gap: 24px; overflow-y: scroll; height: 300px;"
            @start="onDraggableStart"
            @end="onDraggableEnd"
          >
            <template v-for="header in userHeadersLazy">
              <column-select-item
                v-if="header.selectable !== false"
                :key="header.value"
                v-model="header.selected"
              >
                {{ trans.headersText[header.value] }}
              </column-select-item>
            </template>
          </draggable>
        </card-content>
        <card-actions class="pb-5">
          <v-spacer />
          <v-btn depressed color="primary" @click="apply">
            {{ trans.apply }}
          </v-btn>
        </card-actions>
      </v-card>
    </template>
  </v-menu>
</template>

<script>
import draggable from "vuedraggable";
import ColumnSelectItem from "./ColumnSelectItem.vue";
import { cloneDeep } from "lodash";
import { useDraggable } from "@/use/Draggable";
import { ref } from "vue";

export default {
  components: {
    ColumnSelectItem,
    draggable
  },
  model: {
    prop: "userHeaders"
  },
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    userHeaders: {
      type: Array,
      default: () => []
    },
    columnSelectProps: {
      type: Object,
      default: () => {
        return { left: true };
      }
    },
    btnStyle: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    trans() {
      const headersText = {};

      for (const header of this.headers) {
        headersText[header.value] = header.text ?? header.value;
      }

      return {
        tableSettings: this.$t("ColumnSelect.tableSettings"),
        selectOrderColumns: this.$t("ColumnSelect.selectOrderColumns"),
        apply: this.$t("Common.apply"),
        headersText
      };
    }
  },
  watch: {
    headers() {
      this.userHeadersLazy = cloneDeep(this.userHeaders);
    },
    menu(val) {
      if (val) {
        this.userHeadersLazy = cloneDeep(this.userHeaders);
      }
    }
  },
  methods: {
    apply() {
      this.$emit("input", cloneDeep(this.userHeadersLazy));
      this.menu = false;
    }
  },
  setup(props) {
    const userHeadersLazy = ref(props.userHeaders.slice());

    const { onDraggableStart, onDraggableEnd } = useDraggable(
      userHeadersLazy,
      24
    );

    return {
      userHeadersLazy,
      onDraggableEnd,
      onDraggableStart
    };
  }
};
</script>
